(() => {
  const money = cents => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
  const extras = wrap => [...wrap.querySelectorAll('.htl-extra-checkbox:checked, .htl-heat-pump-radio:checked')];
  const update = wrap => {
    const output = wrap.querySelector('.htl-extras-total');
    if (output) output.textContent = money(extras(wrap).reduce((sum, el) => sum + Number(el.dataset.price || 0), 0));
  };
  document.addEventListener('change', event => {
    const wrap = event.target.closest('[data-product-form]');
    if (wrap) update(wrap);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-product-form] .add_to_cart');
    if (!button) return;
    const wrap = button.closest('[data-product-form]');
    const form = button.closest('form');
    if (!form || !wrap) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.disabled || button.classList.contains('disabled') || wrap.dataset.adding === 'true') return;
    addBundle(wrap, form, button);
  }, true);
  document.addEventListener('submit', event => {
    const deposit = event.target.closest('.htl-deposit-form');
    if (!deposit) return;
    const wrap = deposit.closest('[data-product-form]');
    const mainForm = wrap.querySelector('form.shopify-product-form');
    const selected = mainForm && mainForm.querySelector('select[name="id"] option:checked');
    const variantField = deposit.querySelector('[name="properties[Reserved Variant]"]');
    if (selected && variantField) variantField.value = selected.textContent.trim();
    const field = deposit.querySelector('.js-deposit-extras');
    if (field) field.value = extras(wrap).map(el => `${el.closest('label')?.querySelector('.htl-inline-name')?.textContent.trim() || el.dataset.title || 'Extra'} (${money(Number(el.dataset.price || 0))})`).join(' | ') || (window.htlPromotion?.none || 'None selected');
  }, true);
  async function addBundle(wrap, form, button) {
    const data = new FormData(form);
    const id = Number(data.get('id'));
    const quantity = Math.max(1, Number(data.get('quantity') || 1));
    if (!id || !form.reportValidity()) return;
    const properties = {};
    for (const [key, value] of data.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && typeof value === 'string' && value) properties[match[1]] = value;
    }
    const item = { id, quantity, properties };
    if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');
    const items = [item];
    for (const el of extras(wrap)) {
      const extraId = Number(el.dataset.variantId);
      if (extraId) items.push({ id: extraId, quantity });
    }
    const errorBox = wrap.querySelector('.htl-purchase-error');
    if (errorBox) errorBox.textContent = '';
    wrap.dataset.adding = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || window.htlPromotion?.error);
      window.location.assign(`${root}cart`);
    } catch (error) {
      if (errorBox) errorBox.textContent = error.message || window.htlPromotion?.error;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      wrap.dataset.adding = 'false';
    }
  }
})();

(() => {
  function enhanceHome() {
    document.querySelectorAll('[data-htl-home]').forEach(home => {
      if (home.classList.contains('is-enhanced')) return;
      home.classList.add('is-enhanced');
      home.querySelectorAll('[data-htl-reveal-grid]').forEach(button => {
        button.addEventListener('click', () => {
          const grid = document.getElementById(button.getAttribute('aria-controls'));
          if (!grid) return;
          const firstHidden = [...grid.children].find(card => !card.getClientRects().length);
          grid.classList.add('is-expanded');
          button.setAttribute('aria-expanded', 'true');
          firstHidden?.querySelector('h3 a')?.focus({preventScroll: true});
        });
      });
      home.addEventListener('click', event => {
        const link = event.target.closest('[data-htl-home-action]');
        if (link && typeof window.gtag === 'function') {
          window.gtag('event', 'homepage_shopping_click', {
            action: link.dataset.htlHomeAction,
            product_id: link.dataset.productId || '',
            finder_capacity: link.dataset.htlFinderCapacity || ''
          });
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceHome);
  else enhanceHome();
  document.addEventListener('shopify:section:load', enhanceHome);
})();

(() => {
  function enhanceSwimFinders() {
    document.querySelectorAll('[data-htl-swim]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const start = root.querySelector('[data-swim-start]');
      const panel = root.querySelector('[data-swim-form]');
      const questions = root.querySelector('.htl-swim-questions');
      const steps = [...root.querySelectorAll('[data-swim-step]')];
      const cards = [...root.querySelectorAll('[data-swim-card]')];
      const results = root.querySelector('[data-swim-results]');
      const count = root.querySelector('[data-swim-count]');
      const error = root.querySelector('[data-swim-error]');
      const enquiry = root.querySelector('[data-swim-enquiry]');
      const defaultEnquiry = enquiry.href;
      const leadPanel = root.querySelector('[data-swim-lead]');
      const leadForm = root.querySelector('#htlSwimLeadForm');
      leadForm.dataset.finderType = 'swim_spa';
      let leadAnswers = {};
      let showMatches = null;
      let step = 0;
      function focusAndScroll(element) {
        element.focus({ preventScroll: true });
        element.scrollIntoView({ behavior: 'instant', block: 'center' });
      }
      function showStep() {
        steps.forEach((field, index) => { field.hidden = index !== step; });
        root.querySelector('[data-swim-step-number]').textContent = step + 1;
        root.querySelector('[data-swim-back]').hidden = step === 0;
        root.querySelector('[data-swim-next]').hidden = step === 2;
        root.querySelector('[data-swim-finish]').hidden = step !== 2;
        error.hidden = true;
        focusAndScroll(steps[step].querySelector('legend'));
      }
      function reset() {
        panel.reset();
        step = 0;
        results.hidden = true;
        leadPanel.hidden = true;
        delete leadForm.dataset.htlSubmitted;
        root.querySelector('.htl-swim-grid').hidden = false;
        cards.forEach(card => { card.hidden = false; });
        enquiry.href = defaultEnquiry;
      }
      start.addEventListener('click', event => {
        event.preventDefault();
        if (leadForm.dataset.htlSubmitting === 'true') return;
        reset();
        questions.hidden = false;
        start.setAttribute('aria-expanded', 'true');
        showStep();
      });
      root.querySelector('[data-swim-close]').addEventListener('click', () => {
        questions.hidden = true;
        start.setAttribute('aria-expanded', 'false');
        start.focus();
      });
      root.querySelector('[data-swim-back]').addEventListener('click', () => {
        if (step > 0) { step -= 1; showStep(); }
      });
      panel.addEventListener('change', () => { error.hidden = true; });
      panel.addEventListener('submit', event => {
        event.preventDefault();
        if (!steps[step].querySelector('input:checked')) {
          error.hidden = false;
          steps[step].querySelector('input').focus();
          return;
        }
        if (step < 2) { step += 1; showStep(); return; }
        questions.hidden = true;
        leadPanel.hidden = true;
        const selected = [...panel.querySelectorAll('input:checked')].map(input => input.closest('label').textContent.trim());
        leadAnswers = { purpose: selected[0], size: selected[1], budget: selected[2] };
        showMatches = () => {
        const answers = new FormData(panel);
        const purpose = answers.get('swim-purpose');
        const length = answers.get('swim-space');
        const budget = answers.get('swim-budget');
        let matches = 0;
        cards.forEach(card => {
          const price = Number(card.dataset.price) / 100;
          const purposeMatch = purpose === 'any' || purpose === 'family' || (purpose === 'fitness' && card.dataset.swimming === 'true') || (purpose === 'dual' && card.dataset.dual === 'true');
          const sizeMatch = length === 'any' || Number(card.dataset.length) < Number(length);
          const priceMatch = budget === 'any' || (budget === 'low' && price < 15000) || (budget === 'mid' && price >= 15000 && price <= 25000) || (budget === 'high' && price > 25000 && price <= 35000);
          card.hidden = !(purposeMatch && sizeMatch && priceMatch);
          if (!card.hidden) matches += 1;
        });
        count.textContent = matches ? `${matches} ${matches === 1 ? count.dataset.one : count.dataset.many}` : count.dataset.empty;
        const summary = [...panel.querySelectorAll('input:checked')].map(input => input.closest('label').textContent.trim()).join(' · ');
        root.querySelector('[data-swim-summary]').textContent = summary;
        enquiry.href = `https://wa.me/447736578751?text=${encodeURIComponent(`${enquiry.dataset.intro} ${summary}`)}`;
        questions.hidden = true;
        start.setAttribute('aria-expanded', 'false');
        leadPanel.hidden = true;
        root.querySelector('.htl-swim-grid').hidden = false;
        root.querySelector('.htl-swim-grid').classList.add('is-expanded');
        const revealButton = root.querySelector('[data-htl-reveal-grid]');
        if (revealButton) revealButton.setAttribute('aria-expanded', 'true');
        results.hidden = false;
        focusAndScroll(results.querySelector('h3'));
        document.dispatchEvent(new CustomEvent('htl:finder-results', {detail:{count:matches,type:'swim_spa'}}));
        };
        showMatches();
      });
      root.querySelector('[data-swim-advice]').addEventListener('click', () => { leadPanel.hidden = false; focusAndScroll(leadPanel.querySelector('h3')); });
      leadForm.addEventListener('submit', event => {
        event.preventDefault();
        if (showMatches && typeof window.htlSubmitFinderLead === 'function') window.htlSubmitFinderLead(leadForm, leadAnswers, showMatches);
      });
      root.querySelector('[data-swim-edit]').addEventListener('click', () => {
        if (leadForm.dataset.htlSubmitting === 'true') return;
        leadPanel.hidden = true;
        questions.hidden = false;
        root.querySelector('.htl-swim-grid').hidden = false;
        step = 2;
        showStep();
      });
      root.querySelector('[data-swim-reset]').addEventListener('click', () => {
        reset();
        questions.hidden = false;
        start.setAttribute('aria-expanded', 'true');
        showStep();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceSwimFinders);
  else enhanceSwimFinders();
  document.addEventListener('shopify:section:load', enhanceSwimFinders);
})();

